var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5133 16.646C11.6529 16.779 11.8321 16.8453 12.0105 16.8453C12.2 16.8453 12.3899 16.7709 12.5309 16.6226L17.0476 11.8949C17.3222 11.6073 17.3121 11.1512 17.0245 10.8767C16.7369 10.6024 16.2815 10.6122 16.0063 10.9001L12.7679 14.2895V4.07998C12.7679 3.68221 12.4458 3.36011 12.048 3.36011C11.6503 3.36011 11.3282 3.68221 11.3282 4.07998V14.4773L8.04285 11.339C7.75524 11.0644 7.29987 11.0745 7.02464 11.3624C6.75008 11.65 6.76013 12.1061 7.04774 12.3806L11.5133 16.646Z",
    fill: "#3956C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2562 19.2002H3.83999C3.44222 19.2002 3.12012 19.5226 3.12012 19.9201C3.12012 20.3175 3.44222 20.6399 3.83999 20.6399H20.2562C20.654 20.6399 20.9761 20.3175 20.9761 19.9201C20.9764 19.523 20.6543 19.2002 20.2562 19.2002Z",
    fill: "#3956C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/iconDownload.41a7573f8f675d12f05c0b3985817bc0.svg";
export { ForwardRef as ReactComponent };